/**
 * Shared section-plane palette.
 * Single source of truth for the cursor SVG and the placed-plane gizmo.
 */

import { VecRGB } from "utils/color";

/** Neon green - ring/outline stroke, solid gizmo hub, drag highlight. */
export const SECTION_PLANE_NEON = "#56ff77";
/** Dark green - arrow front-half fill, cursor inner ellipse. */
export const SECTION_PLANE_DARK_GREEN = "#194d1e";
/** Mid green - arrow back-half fill (behind the plane). */
export const SECTION_PLANE_ARROW_BACK = "#00851a";

/**
 * Object hover highlight and the cut/profile outlines.
 */
export const SECTION_PLANE_HIGHLIGHT_GREEN_RGB: VecRGB = [0.3373, 1.0, 0.4667];
